import React from "react";
import {YouTubeEmbed} from 'react-social-media-embed';
import {v4 as uuidv4} from 'uuid';
import loadable from "@loadable/component";
const youtube = require("./youtube.json");
const Grid = loadable(() => import('@material-ui/core/Grid'));

function Youtube(props) {
    let count = 0;
    const items = youtube.map((embed, index) => {
        let random = Math.floor(Math.random() * 3);
        let results = ((index+(random*2)) % random) === 0;
        if(results === true && count <= 5) {
            count++
            return(
                <Grid item key={uuidv4()} md={4}>
                    <YouTubeEmbed url={embed} width={325} height={180} />
                </Grid>
            )
        }
        return true;
    });
    return (
        <Grid container spacing={3} justifyContentclear
            ="center" style={{marginLeft: "30px", marginTop: "40px", marginBottom: "30px"}}>
            {items}
        </Grid>
    )
}
export default Youtube;